'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Suspense, lazy, memo } from 'react';
import { ParagraphContainer } from './styles';
import useTypographyProps from './utils/use-typography-props';
const CopyButton = lazy(() => import('./copyButton'));
const Content = (props) => {
    const { currentProps, defaultProps } = useTypographyProps(props);
    const { parseHtml } = props;
    const { className, onBlur, onClick, onMouseEnter, onMouseLeave, onPointerEnter, onPointerLeave, id, children, } = defaultProps;
    const classes = classNames(className, 'hd-paragraph');
    const textProps = Object.assign(Object.assign({}, currentProps), { className: classes, onClick,
        onBlur,
        onMouseEnter,
        onMouseLeave,
        onPointerEnter,
        onPointerLeave,
        id });
    if (parseHtml && typeof children === 'string') {
        return (_jsx(ParagraphContainer, Object.assign({}, textProps, { dangerouslySetInnerHTML: { __html: children } })));
    }
    return _jsx(ParagraphContainer, Object.assign({}, textProps, { children: children }));
};
const Paragraph = memo((props) => {
    const { copyable } = props;
    return !!copyable ? (_jsxs("div", { style: {
            display: 'flex',
            gap: 8,
            alignItems: 'center',
        }, children: [_jsx(Content, Object.assign({}, props)), !!copyable ? (_jsx(Suspense, { fallback: '', children: _jsx(CopyButton, { copyable: copyable }) })) : undefined] })) : (_jsx(Content, Object.assign({}, props)));
});
Paragraph.displayName = 'Typography';
export default Paragraph;
